import { type TwoFactorAuthType } from '@pkg/types/enums';

import { type Roles } from '@app/client/common/structs/user/roles';

export const ACTION_SET_ADMIN_INFO = 'ACTION_SET_ADMIN_INFO';
export const ACTION_SET_ADMIN_INFO_ENABLE_INTERVAL = 'ACTION_SET_ADMIN_INFO_ENABLE_INTERVAL';

//todo rename or refactor when have time
export interface AdminInfoState {
    information: AdminInfo | null;
    enableIntervalCheck: boolean;
}

export interface AdminInfo {
    host?: string;
    email?: string;
    role?: Roles;
    apiVersion?: string;
    webVersion?: string;
    zoom?: number;
    screenSize?: string;
    viewSize?: string;
    twoFactorAuthTypes?: TwoFactorAuthType[];
    twoFactorExpiresAt?: number;
    accessTokenExpiresAt?: number;
    refreshTokenExpiresAt?: number;
}

interface SetAdminInfo {
    type: typeof ACTION_SET_ADMIN_INFO;
    information: AdminInfo | null;
}

interface SetEnableIntervalCheck {
    type: typeof ACTION_SET_ADMIN_INFO_ENABLE_INTERVAL;
    enableIntervalCheck: boolean;
}

export type AdminInfoActionTypes = SetAdminInfo | SetEnableIntervalCheck;
